import React from "react";
import { Link } from "react-router-dom";
import Time from "react-time-format";
import { ProductConsumer } from "../../../Context/AddProWakel";
const FillDetailKoga3arz = () => {
  return (
    <>
      <ProductConsumer>
        {(value) => {
          const { AddProChange, KD_name, KD_code, KD_draw, getPrint } = value;
          return (
            <>
              <div className="row" style={{ backgroundColor: "#2C3539" }}>
                <div className="col-lg-3 col-5 form-inline">
                  <div className="row form-inline">
                    <div className="col-12 form-inline">
                      <span style={{ color: "#2C3539" }}>:</span>
                      <Link to="/print-mawad" onClick={getPrint}>
                        <button className="btn btn-warning ml-4">چاپ</button>
                      </Link>
                    </div>
                  </div>
                </div>
                <div className="col-lg-5 col-7  mt3">
                  <div className="row">
                    <div className="col-6">
                      <input
                        type="text"
                        name="KD_name"
                        value={KD_name}
                        onChange={AddProChange}
                        aria-label="Large"
                        className="form-control"
                        placeholder="گەڕان بە ناو"
                      />
                    </div>
                    <div className="col-3">
                      <input
                        type="text"
                        name="KD_code"
                        value={KD_code}
                        onChange={AddProChange}
                        aria-label="Large"
                        className="form-control"
                        placeholder="گەڕان بە کۆد"
                      />
                    </div>
                    <div className="col-3">
                      <label className="text-warning f4 font-weight-bold">
                        گەڕان
                      </label>
                    </div>
                  </div>
                  <br />
                </div>
                <div className="col-lg-4 col-6 mt3">
                  <div className="row">
                    <div className="col-lg-3 col-3">
                      {/* <Link to="/print-Koga">
            <button className="btn  btn-secondary ml3" onClick={RKP_getPrint}>
             چاپکردن
            </button>
           </Link> */}
                    </div>
                    <div className="col-lg-6 col-6 text-warning f4 font-weight-bold">
                      ڕاپۆرتی زانیاری كاڵا
                    </div>
                    <div className="col-lg-3 col-3"></div>
                  </div>
                </div>
              </div>
            </>
          );
        }}
      </ProductConsumer>
    </>
  );
};

export default FillDetailKoga3arz;
